import { getMeta } from "app/utils/meta";
import { getLoaderTrans } from "app/.server/utils";
import Layout from "app/components/layout";
import {
  HeroSection,
  TeamAndLocationsSection,
  ValuesSection,
} from "app/sections/about-us";

export const loader = async ({ request, params }) => {
  const trans = await getLoaderTrans({ request, params });

  return {
    meta: {
      title: `${trans("About us")} | ${trans("Pioneering the cCommerce revolution")}`,
      description: trans(
        "Since 2016, Zbooni has been at the forefront of social commerce, delivering best-in-class service and products for you and your customers."
      ),
    },
  };
};

export const meta = ({ loaderData: data }) =>
  getMeta({
    title: data.meta.title,
    description: data.meta.description,
  });

const AboutUs = () => {
  return (
    <Layout headerIsOnTop={false} enableHeaderShrinkingOnScroll={false}>
      <HeroSection />
      <ValuesSection />
      <TeamAndLocationsSection />
    </Layout>
  );
};

export default AboutUs;
